export interface IColumn {
  id: string;
  name: string;
  nameModified?: boolean;
  editable: boolean;
  position: number;
  loading?: boolean;
  funnelTag?: string;
  featureGuard?: string;
  listerineFF?: boolean;
  screeningFF?: boolean;
}

export class Column {

  public static Test(): Column {
    return new Column({
      id: "1",
      name: "Other",
      nameModified: false,
      editable: true,
      position: 0
    });
  }

  public id: string;
  public name: string;
  public nameModified?: boolean;
  public editable: boolean;
  public position: number;
  public loading?: boolean;
  public funnelTag?: string;
  public featureGuard?: string;
  public listerineFF?: boolean;
  public screeningFF?: boolean;

  constructor(data: IColumn) {
    this.id = data.id;
    this.name = data.name;
    this.nameModified = data.nameModified;
    this.editable = data.editable;
    this.position = data.position;
    this.loading = data.loading;
    this.funnelTag = data.funnelTag;
    this.featureGuard = data.featureGuard;
    this.listerineFF =  data.listerineFF;
    this.screeningFF = data.screeningFF;
  }
}

export interface IAddColumnRequest {
  name: string;
  position: number;
  funnelTag?: string;
}

export interface IUpdateColumnRequest extends IAddColumnRequest {
  id: string;
}
